<template lang="pug">
  .record.column.pointer(@click='toggleAll')
    h5.blue.text-small.m-bottom-1.row.content.middle {{ tagName }}
    h2.title-small.m-bottom-05(v-if='record.educationalProgramCompleted')
      | {{ record.educationalProgramName }}
    ul.column.m-bottom-05(v-else)
      li.title-small(v-for='resource in record.resources')
        | {{ getResourceName(resource) }}
    h3.text-normal.m-bottom-1
      | {{ $t("usedContent.usedContentCard.teacher", {teacher: record.user.fullName}) }}
    p.note.italic.text-normal.dark-gray(:class='{ellipsis: !showAll}') {{ record.note }}
    h3.m-top-1.text-small.dark-gray {{ parseDate(record.useDate) }}
</template>

<script>
import moment from 'moment'
import { i18n } from '../../main'
import { mapState } from 'vuex'
import { localesToMoment } from '../../constants/languages'

export default {
  props: {
    record: { type: Object },
    contentType: { type: String }
  },
  data() {
    return {
      showAll: false
    }
  },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale
    }),
    tagName() {
      return this.record.educationalProgramCompleted
        ? i18n.t('usedContent.usedContentCard.content')
        : i18n.t('usedContent.usedContentCard.resource')
    }
  },
  methods: {
    toggleAll() {
      this.showAll = !this.showAll
    },
    getResourceName({ resourceCompleted, resourceName, classPlans }) {
      return resourceCompleted
        ? resourceName
        : `${resourceName}: ${classPlans.map(({ classNumber }) => i18n.t('usedContent.usedContentCard.classNumber', { classNumber })).join(', ')}`
    },
    parseDate(date) {
      return moment(date).locale(localesToMoment[this.locale]).format('MMMM YYYY')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.record{
  background-color: $white;
  padding: 15px;
  border: 1px solid $gray;
  border-radius: 5px;
  .header{
    border-bottom: 1px solid $light-gray;
    padding-bottom: 6px;
    margin-bottom: 15px;
  }
  .note{
    &.ellipsis{
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      white-space: pre-wrap;
    }
  }
  .content::before{
    content: "";
    left: 0;
    width: 5px;
    height: 5px;
    margin-right: 10px;
    border-radius: 50%;
    background-color: $blue;
  }
}
</style>
